import { render, staticRenderFns } from "./TimeStudy.vue?vue&type=template&id=56c6a17a&scoped=true&"
import script from "./TimeStudy.vue?vue&type=script&lang=js&"
export * from "./TimeStudy.vue?vue&type=script&lang=js&"
import style0 from "./TimeStudy.vue?vue&type=style&index=0&id=56c6a17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6a17a",
  null
  
)

export default component.exports